const API_BASE_URL = process.env.REACT_APP_TRAVEL_API_BASE_URL;

export interface TransferSearchParams {
  cityId: string;
  airportCode: string;
  hotelCode: string;
  pickupFromAirport: boolean;
  pickupDate: string; // YYYY-MM-DD
  pickupTime: string; // HH:mm
  passengers: number;
  bags: number;
  page?: number;
  limit?: number;
}

export interface TransferVehiclePrice {
  CurrencyCode?: string;
  BasePrice?: number;
  PublishedPrice?: number;
  OfferedPrice?: number;
}

export interface TransferVehicleOption {
  VehicleIndex?: number;
  Vehicle?: string;
  VehicleCode?: string;
  VehicleMaximumPassengers?: number;
  VehicleMaximumLuggage?: number;
  TransferPrice?: TransferVehiclePrice;
}

export interface TransferItem {
  provider: string;
  productCode?: string;
  name: string;
  price?: number;
  currency?: string;
  meta: any;
}

export interface TransfersPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface TransfersResponse<T = TransferItem> {
  items: T[];
  pagination: TransfersPagination;
}

export const searchTransfers = async (params: TransferSearchParams): Promise<TransfersResponse> => {
  const res = await fetch(`${API_BASE_URL}/transfers/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...params, page: params.page ?? 1, limit: params.limit ?? 50 }),
  });

  if (!res.ok) {
    throw new Error(`Failed to search transfers (${res.status} ${res.statusText})`);
  }

  return res.json();
};

